export default "__VITE_ASSET__249c805b__"